const storyMap = {
  selectProject: "Select project",
  noProjects: "No projects",
  addEpic: "Add Epic",
  addStory: "Add Story",
  editCard: "Edit card",
  deleteCard: "Delete card",
  deleteColumn: "Delete column",
  deleteColumnConfirm: "Delete this column and all its cards?",
  epicPlaceholder: "Epic name...",
  storyPlaceholder: "Story name...",
  subStories: "Sub-stories",
  addSub: "Add sub-story",
  subPlaceholder: "Sub-story...",
  emptyBoard: "Board is empty — add the first epic",
  demoMode: "Demo mode",
  demoModeHint: "Demo data — no Supabase connection. Data is not real.",
  colorPicker: "Color",
  noColor: "No color",
  cardCount: "cards",
  addFeature: "Add Feature",
  featurePlaceholder: "Feature name...",
  realtimeConnected: "Connected",
  realtimeConnecting: "Connecting...",
  realtimeDisconnected: "Disconnected",
  notes: "Notes",
  addNote: "Add note",
  notePlaceholder: "Notes, criteria, links...",
  diagram: "Diagram",
  editDiagram: "Edit diagram",
  diagramPlaceholder: "graph TD\n  A-->B",
  preview: "Preview",
  save: "Save",
  filterSearch: "Search cards...",
  clearFilters: "Clear filters",
  epic: "Epic",
  feature: "Feature",
  story: "Story",
  statsEpics: "Epics",
  statsFeatures: "Features",
  statsStories: "Stories",
  statsCompletion: "Sub-story completion",
  statsTotal: "Total cards",
  estimation: "Estimation",
  noEstimation: "No estimation",
  totalPoints: "Total points",
  export: "Export",
  exportJSON: "Export JSON",
  exportMarkdown: "Export Markdown",
  exportPNG: "Export PNG",
  exporting: "Exporting...",
  openInEditor: "Open in Editor",
  createNote: "Creating note...",
  hasNote: "Has linked note",
  linkEntity: "Link entity",
  linkedEntities: "Linked entities",
  searchEntity: "Search entity to link...",
  unlinkEntity: "Unlink",
  noLinkedEntities: "No linked entities",
  defaultEpic: "Epic",
  defaultFeature: "New Feature",
  defaultStory: "New story",
} as const;
export default storyMap;
